export default __webpack_public_path__ + "static/media/map_position.e4aeb57c.svg";